module.exports = __webpack_public_path__ + "img/sft_logo.4c5426a4.svg";